import React, { useEffect, useState } from 'react';

import { ConfigSwitchSection, ParentAwareSaveBar } from '../../../common';
import { inheritableLabelsFromConfigNames } from '../../../util/parentSettingSave';
import { ConfigResponse } from '../../../store/modules/merchant/types';

type Props = {
  readOnly?: boolean;
  isSaving?: boolean;
  onSave: (paylinksRecurringCheckbox: boolean) => Promise<void>;
  paylinksRecurringCheckboxConfig?: ConfigResponse<boolean>;
};

function getServerPaylinksRecurringCheckbox(config?: ConfigResponse<boolean>): boolean {
  return Boolean(config?.value);
}

export const PaylinkRecurringCheckboxContent = ({
  onSave,
  paylinksRecurringCheckboxConfig,
  readOnly = false,
  isSaving = false,
}: Props) => {
  const serverValue = getServerPaylinksRecurringCheckbox(paylinksRecurringCheckboxConfig);

  const [paylinksRecurringCheckbox, setPaylinksRecurringCheckbox] = useState(serverValue);

  // Align draft state when configs load/refetch after save or navigation (avoid false !== undefined dirty state).
  useEffect(() => {
    setPaylinksRecurringCheckbox(serverValue);
  }, [serverValue]);

  const isSaveBarOpen = paylinksRecurringCheckbox !== serverValue;

  const resetValues = () => {
    setPaylinksRecurringCheckbox(serverValue);
  };

  const handleSave = async () => {
    await onSave(paylinksRecurringCheckbox);
  };

  return (
    <>
      <ConfigSwitchSection
        title="Save cards for future transactions"
        description={
          'Enable the option to save cards for future transactions when creating a Paylink.' +
          ' When enabled, all Paylinks will require saving new customers, or using existing customers.'
        }
        isChecked={paylinksRecurringCheckbox}
        onToggle={() => setPaylinksRecurringCheckbox(!paylinksRecurringCheckbox)}
        disabled={readOnly}
        switchTestId="PAYLINKS_RECURRING_CHECKBOX"
      />
      <ParentAwareSaveBar
        disableSave={readOnly || isSaving}
        saveLoading={isSaving}
        show={isSaveBarOpen && !readOnly}
        onCancel={() => resetValues()}
        inheritableSettingLabels={
          isSaveBarOpen ? inheritableLabelsFromConfigNames(['PAYLINKS_RECURRING_CHECKBOX']) : []
        }
        onSave={handleSave}
      />
    </>
  );
};
